import { definePreset, palette } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

export const appTheme = definePreset(Aura, {
  semantic: {
    primary: palette("#4641D5"),
  },
  components: {
    button: {
      root: {
        borderRadius: "8px",
        paddingX: "16px",
        gap: "8px",
      },
    },
    message: {
      text: {
        fontWeight: "400",
        sm: {
          fontSize: "0.75rem",
        },
      },
    },
    inputgroup: {
      addon: {
        background: "rgba(0,0,0,0.04)",
        color: "#000",
      },
    },
    datepicker: {
      date: {
        borderRadius: "8px",
      },
    },
    stepper: {
      step: {
        number: {
          active: {
            background: "{primary.color}",
            borderColor: "{primary.color}",
            color: "{primary.contrast.color}",
          },
        },
        title: {
          active: {
            color: "black",
          },
          font: {
            weight: "normal",
          },
        },
      },
      steppanels: {
        padding: "16px 8px",
      },
    },
    dialog: {
      header: {
        padding: "24px 24px 20px 24px",
      },
      content: {
        padding: "0 16px 16px",
      },
    },
    divider: {
      root: {
        borderColor: "#D9D9D9",
      },
    },
    chip: {
      root: {
        borderRadius: "4px",
      },
    },
  },
});
